module.exports = __webpack_public_path__ + "ee37b5e6e182db61ac626e7a35634c7b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/3_D2.mp3
// module id = 100
// module chunks = 0